export default __webpack_public_path__ + "static/media/Artboard 3.069d0702.png";